// src/components/Menu.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api from "../api";
import "./menu.css";

const Menu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthenticated = !!localStorage.getItem("authToken");

  // Busca nome do usuário para saudação
  useEffect(() => {
    const fetchMe = async () => {
      try {
        if (!isAuthenticated) return;
        const token = localStorage.getItem("authToken");
        const headers = { Authorization: `Bearer ${token}` };
        const meRes = await api.get("/api/players/me", { headers });
        const name = meRes?.data?.display_name || meRes?.data?.nome || "";
        setDisplayName(name);
      } catch {
        setDisplayName("");
      }
    };
    fetchMe();
    // fecha o drawer quando navegar
    setIsMenuOpen(false);
  }, [isAuthenticated, location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const firstName = (displayName || "").split(" ")[0] || "";

  return (
    <header className="menu-wrapper">
      <div className="menu-inner">
        {/* Logo (paisagem, png fundo transparente) */}
        <div
          className="menu-left"
          onClick={() => navigate("/dashboard")}
          role="button"
          tabIndex={0}
        >
          <img
            src="https://futebotfc.com.br/imagens/futebotpaisagemescuro.png"
            alt="Futebot"
            className="menu-logo-landscape"
            draggable="false"
          />
        </div>

        {/* Saudação central */}
        <div className="menu-center">
          <div className="menu-greet">
            <span className="hello">Olá{firstName ? "," : ""}</span>{" "}
            <span className="username">{firstName || "bem-vindo(a)"}</span>
          </div>
        </div>

        {/* Ações à direita */}
        <div className="menu-right">
          <button
            className="btn-mini btn--ghost-mini"
            onClick={() => navigate("/editar-dados")}
            title="Editar perfil"
          >
            Editar
          </button>

          {isAuthenticated && (
            <button
              className="btn-mini btn--ghost-mini"
              onClick={handleLogout}
              title="Sair"
            >
              Logout
            </button>
          )}

          {/* Botão hambúrguer (mobile) */}
          <button
            className="hamburger"
            onClick={toggleMenu}
            aria-label="Abrir menu"
            aria-expanded={isMenuOpen}
          >
            <span className={`line ${isMenuOpen ? "open" : ""}`}></span>
            <span className={`line ${isMenuOpen ? "open" : ""}`}></span>
            <span className={`line ${isMenuOpen ? "open" : ""}`}></span>
          </button>
        </div>
      </div>

      {/* Nav expansível (mobile) */}
      <nav
        className={`menu-drawer ${isMenuOpen ? "active" : ""}`}
        aria-hidden={!isMenuOpen}
      >
        <ul>
          <li>
            <Link to="/dashboard" onClick={() => setIsMenuOpen(false)}>
              Dashboard
            </Link>
          </li>
          <li>
            <Link to="/editar-dados" onClick={() => setIsMenuOpen(false)}>
              Perfil
            </Link>
          </li>
          <li>
            <button
              className="auth-button"
              onClick={() => {
                setIsMenuOpen(false);
                handleLogout();
              }}
            >
              {isAuthenticated ? "Logout" : "Login"}
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Menu;
